function RGBToHex(numbers?: ({ r: number, g: number, b: number }), str?: string): string {
	if (numbers) {
		const rHex = NumberToHex(numbers.r);
		const gHex = NumberToHex(numbers.g);
		const bHex = NumberToHex(numbers.b);
		return '#' + rHex + gHex + bHex;
	} else if (str) {

		const separator = str.includes(',') ? ',' : ' ';
		let rgb = str.substr(4).split(')')[0].split(separator);

		if (rgb.find((v) => v.includes('%'))) {
			rgb = rgb.map((v) => Math.round(parseInt(v.substr(0, v.length - 1), 10) / 100 * 255) + '');
		}

		const rHex = NumberToHex(parseInt(rgb[0], 10));
		const gHex = NumberToHex(parseInt(rgb[1], 10));
		const bHex = NumberToHex(parseInt(rgb[2], 10));
		return '#' + rHex + gHex + bHex;
	} else {
		return '';
	}
}

function HexToRGB(hex: string, isPercent?: boolean): string {
	let r = 0;
	let g = 0;
	let b = 0;
	const percent = isPercent === true;
	if (hex.length === 4) {
		r = parseInt(hex[1] + hex[1], 16);
		g = parseInt(hex[2] + hex[2], 16);
		b = parseInt(hex[3] + hex[3], 16);
	} else if (hex.length === 7) {
		r = parseInt(hex[1] + hex[2], 16);
		g = parseInt(hex[3] + hex[4], 16);
		b = parseInt(hex[5] + hex[6], 16);
	}

	if (percent) {
		r = parseInt((r / 255 * 100).toFixed(1), 10);
		g = parseInt((g / 255 * 100).toFixed(1), 10);
		b = parseInt((b / 255 * 100).toFixed(1), 10);

		return `rgb(${r}%,${g}%,${b}%)`;
	}

	return `rgb(${r},${g},${b})`;
}

function RGBToHSL(numbers?: ({ r: number, g: number, b: number }), str?: string): string {
	let r = 0;
	let g = 0;
	let b = 0;
	if (numbers) {
		r = numbers.r / 255;
		g = numbers.g / 255;
		b = numbers.b / 255;
	} else if (str) {
		const separator = str.includes(',') ? ',' : ' ';
		const rgbStr = str.substr(4).split(')')[0].split(separator);

		r = rgbStr[0].includes('%')
			? Math.round(parseInt(rgbStr[0].substr(0, rgbStr[0].length - 1), 10) / 100 * 255)
			: parseInt(rgbStr[0], 10);
		g = rgbStr[1].includes('%')
			? Math.round(parseInt(rgbStr[1].substr(0, rgbStr[1].length - 1), 10) / 100 * 255)
			: parseInt(rgbStr[1], 10);
		b = rgbStr[2].includes('%')
			? Math.round(parseInt(rgbStr[2].substr(0, rgbStr[2].length - 1), 10) / 100 * 255)
			: parseInt(rgbStr[2], 10);

		r = r / 255;
		g = g / 255;
		b = b / 255;
	}

	const cmin = Math.min(r, g, b);
	const cmax = Math.max(r, g, b);
	const delta = cmax - cmin;
	let h = 0;
	if (cmax === r) {
		h = ((g - b) / delta) % 6;
	} else if (cmax === g) {
		h = (b - r) / delta + 2;
	} else {
		h = (r - g) / delta + 4;
	}
	h = Math.round(h * 60);
	if (h < 0) {
		h += 360;
	}
	let l = (cmax + cmin) / 2;
	let s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
	l = parseInt((l * 100).toFixed(1), 10);
	s = parseInt((s * 100).toFixed(1), 10);

	return `hsl(${h},${s}%,${l}%)`;
}

function HSLToRGB(numbers?: ({ h: number, s: number, l: number }), str?: string) {
	let h = 0;
	let s = 0;
	let l = 0;

	if (numbers) {
		h = numbers.h;
		s = numbers.s / 100;
		l = numbers.l / 100;
	} else if (str) {
		const separator = str.includes(',') ? ',' : ' ';
		const hslStr = str.substr(4).split(')')[0].split(separator);
		h = parseInt(hslStr[0], 10);
		s = parseInt(hslStr[1].substr(0, hslStr[1].length - 1), 10) / 100;
		l = parseInt(hslStr[2].substr(0, hslStr[2].length - 1), 10) / 100;
		h = h >= 360 ? h % 360 : h;
	}

	const chroma = (1 - Math.abs(2 * l - 1)) * s;
	const x = chroma * (1 - Math.abs((h / 60) % 2 - 1));
	const m = l - chroma / 2;

	let r = 0;
	let g = 0;
	let b = 0;

	if (0 <= h && h < 60) {
		r = chroma; g = x; b = 0;
	} else if (60 <= h && h < 120) {
		r = x; g = chroma; b = 0;
	} else if (120 <= h && h < 180) {
		r = 0; g = chroma; b = x;
	} else if (180 <= h && h < 240) {
		r = 0; g = x; b = chroma;
	} else if (240 <= h && h < 300) {
		r = x; g = 0; b = chroma;
	} else if (300 <= h && h < 360) {
		r = chroma; g = 0; b = x;
	}
	r = Math.round((r + m) * 255);
	g = Math.round((g + m) * 255);
	b = Math.round((b + m) * 255);

	return `rgb(${r},${g},${b})`;
}

function HexToHSL(hex: string): string {
	const rgb = HexToRGB(hex);
	const hsl = RGBToHSL(undefined, rgb);
	return hsl;
}

function HSLToHex(numbers: ({ h: number, s: number, l: number })): string {
	const rgb = HSLToRGB(numbers);
	const hex = RGBToHex(undefined, rgb);
	return hex;
}

function GetHSLObject(hsl: string) {
	const separator = hsl.includes(',') ? ',' : ' ';
	const hslStr = hsl.substr(4).split(')')[0].split(separator);
	let h = parseInt(hslStr[0], 10);
	const s = parseInt(hslStr[1].substr(0, hslStr[1].length - 1), 10);
	const l = parseInt(hslStr[2].substr(0, hslStr[2].length - 1), 10);
	h = h >= 360 ? h % 360 : h;

	return { h, s, l };
}

function NumberToHex(n: number) {
	const hex = n.toString(16);
	if (hex.length === 1) {
		return `0${hex}`;
	} else {
		return hex;
	}
}

function darkenBy20(hex: string) {
	const hsl = GetHSLObject(HexToHSL(hex));
	hsl.l -= 20;
	return HSLToHex(hsl);
}

export { RGBToHex, HexToRGB, RGBToHSL, HSLToRGB, HexToHSL, HSLToHex, GetHSLObject, darkenBy20 };
